/**
 * Created by mohameds on 17/7/19.
 */
import React from 'react';
import myPic from '../../public/assets/images/agencyMonitor/goal.png';


const Quote = ({pageData = {}, settings={}}) => (
    <div className="qoute-image quote-image-height"
        style={settings && settings.show_header ? {}: {height: '930px'}}
    >
        <img src={pageData.image ? pageData.image : myPic} 
            onError={(e) => {console.log(e.target)}}
            alt={pageData.occasion_text && pageData.occasion_text}
        />
    </div>
)
export default Quote;



// WEBPACK FOOTER //
// ./src/components/agencyMonitor/Quote.js